/** Estado (US) desde una dirección de Google Places — espejo del helper del backend. */
export const US_STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY', 'DC'];
const SET = new Set(US_STATES);

/** Devuelve el estado de 2 letras si se puede inferir de la dirección; si no, null. */
export function stateFromAddress(addr: string | null | undefined): string | null {
  const parts = (addr ?? '').split(',').map((s) => s.trim());
  for (const p of parts) {
    const m = p.match(/^([A-Za-z]{2})(?:\s+\d{5}(?:-\d{4})?)?$/);
    if (m && SET.has(m[1]!.toUpperCase())) return m[1]!.toUpperCase();
  }
  const zip = (addr ?? '').match(/\b([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/);
  if (zip && SET.has(zip[1]!.toUpperCase())) return zip[1]!.toUpperCase();
  return null;
}
